import React from 'react';
import { motion } from 'framer-motion';
import './Benefits.css';

const BoltIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="11" height="11">
    <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
  </svg>
);

const PETS = [
  { name: 'Mika',   breed: 'Shih-Tzu · 4y',   streak: 89, color: '#c5a47e' },
  { name: 'Otto',   breed: 'Bernese · 2y',      streak: 41, color: '#7a8b5a' },
  { name: 'Pip',    breed: 'Pomeranian · 7y',   streak: 12, color: '#a47148' },
  { name: 'Sage',   breed: 'Vizsla · 5y',       streak: 56, color: '#5a6b4a' },
  { name: 'Noodle', breed: 'Dachshund · 3y',    streak:  8, color: '#8a7855' },
];

const CONTAINER = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07 } },
};
const CARD = { hidden: { opacity: 0, y: 6 }, visible: { opacity: 1, y: 0 } };
const CARD_T = { duration: 0.44, ease: [0.22, 1, 0.36, 1] };
const TEXT_T = { duration: 0.52, ease: [0.22, 1, 0.36, 1] };

const Benefits = () => (
  <section className="multi-pet" id="multi-pet">
    <div className="multi-pet-inner">
      <motion.div
        className="multi-pet-text"
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={TEXT_T}
      >
        <div className="eyebrow">Multi-pet</div>
        <h2>One household.<br />Many tails.</h2>
        <p>
          Add every dog (or cat, or rabbit) under one account. Switch between
          profiles with a tap, share an account across the household, and keep
          each pet's history clean and separate.
        </p>
      </motion.div>
      <motion.div
        className="pet-grid"
        variants={CONTAINER}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        {PETS.map((p) => (
          <motion.div key={p.name} className="pet-card" variants={CARD} transition={CARD_T}>
            <div className="pet-avatar" style={{ background: p.color }} />
            <div>
              <div className="pet-name">{p.name}</div>
              <div className="pet-breed">{p.breed}</div>
            </div>
            <div className="pet-streak">
              <BoltIcon />
              <span>{p.streak}</span> day streak
            </div>
          </motion.div>
        ))}
        <motion.div className="pet-card-add" variants={CARD} transition={CARD_T}>+ Add pet</motion.div>
      </motion.div>
    </div>
  </section>
);

export default Benefits;
